import React from 'react'

import { Table, TableCol } from '../../../../../components/pdf/Table'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'

const Signature = () => {
  return (
    <View>
      <Text size={'h5'}>ACEITE E ASSINATURA</Text>
      <Separator weight={5} />
      <Table justify="space-between" width={'100%'}>
        <TableCol>
          <Text>
            <p style={{ borderBottom: '1px solid black' }}>Nome:</p>
          </Text>
          <Text>
            <p style={{ borderBottom: '1px solid black' }}>Data Aceite:</p>
          </Text>
        </TableCol>
        <TableCol>
          <Text>Assinatura:</Text>
        </TableCol>
      </Table>
    </View>
  )
}

export default Signature
